import React from 'react'

import type { IAbsoluteProps } from '../../Node/types'
import * as s from './PreviewAbsolute.module.scss'

const PreviewAbsolute: React.FC<IAbsoluteProps> = ({ children, style }) => {
  return (
    <div className={s.root} style={style}>
      {children}
    </div>
  )
}

export default React.memo(PreviewAbsolute)
